import { render } from "./Browser.vue?vue&type=template&id=d7bd27bc&scoped=true"
import script from "./Browser.vue?vue&type=script&lang=js"
export * from "./Browser.vue?vue&type=script&lang=js"

import "./Browser.vue?vue&type=style&index=0&id=d7bd27bc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7bd27bc"]])

export default __exports__